import React from 'react';
import { FadeIn } from './FadeIn';
export function ProductIntro() {
  return <section className="py-20 px-6 bg-sage-dark text-white text-center" data-id="element-194">
      <div className="max-w-3xl mx-auto" data-id="element-195">
        <FadeIn data-id="element-196">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-8 text-cream" data-id="element-197">
            Presentamos: <br className="md:hidden" data-id="element-198" />
            <span className="text-amber-light italic" data-id="element-199">
              La Botica de la Abuela Moderna
            </span>
          </h2>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl" data-id="element-200">
            <h3 className="text-2xl md:text-3xl font-semibold mb-6 text-cream" data-id="element-201">
              El método SOS Natural: <br className="md:hidden" data-id="element-202" />
              <span className="text-amber-light" data-id="element-203">
                Selección, Origen y Solución.
              </span>
            </h3>

            <p className="text-lg md:text-xl mb-8 leading-relaxed text-cream-dark" data-id="element-204">
              Esta guía en PDF, escrita completamente en español, le enseña paso
              a paso cómo identificar, comprar y preparar los remedios naturales
              más poderosos usando ingredientes que encuentra hoy mismo en
              Walmart, Publix o Kroger.
            </p>

            <p className="text-xl md:text-2xl font-serif italic text-amber-light font-medium" data-id="element-205">
              "No es magia. Es la misma sabiduría de nuestra tierra, adaptada a
              la vida de hoy en USA."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}